import { render } from "./MiDialog.vue?vue&type=template&id=a2d6cc5e"
import script from "./MiDialog.vue?vue&type=script&lang=js"
export * from "./MiDialog.vue?vue&type=script&lang=js"

import "./MiDialog.vue?vue&type=style&index=0&id=a2d6cc5e&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QBtn});qInstall(script, 'directives', {ClosePopup});
